export var isClientError = function isClientError(statusCode) {
  return statusCode.toString().slice(0, 1) === "4";
};